import MediaFile from 'models/core/mediaFile/Model.MediaFile';
import Model from 'models/Model';
import Provider from '../provider/Model.Provider';

export default class ProviderLogo
  extends Model<Model.IProviderLogo>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IProviderLogo>
{
  id: number;
  providerId: number;
  provider: Provider;
  mediaFileId: number;
  mediaFile: MediaFile;
  languageIsoCode: Locale.Languages;

  constructor(data: Partial<Model.IProviderLogo> | Utils.FormData<Model.IProviderLogo>, language?: Locale.Languages) {
    super({ mediaFile: MediaFile, provider: Provider }, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id?.toString(),
    };
  }
}
